import React from 'react';
import { Package } from 'lucide-react';

const TopStock = () => {
  return (
    <div className="space-y-8" data-testid="top-stock-page">
      <div>
        <h1 className="text-4xl font-bold text-slate-900 tracking-tight mb-2">Top Stock</h1>
        <p className="text-slate-600">Weekly pallet verification and tracking</p>
      </div>

      <div className="bg-orange-50 border border-orange-200 rounded-xl p-6">
        <h3 className="text-lg font-semibold text-orange-900 mb-2">Pallet Tracking Progress</h3>
        <div className="flex items-center gap-4">
          <div className="flex-1 bg-orange-200 rounded-full h-3 overflow-hidden">
            <div className="bg-orange-600 h-full rounded-full" style={{ width: '89%' }}></div>
          </div>
          <span className="text-sm font-bold text-orange-900">824 / 917</span>
        </div>
      </div>

      <div className="text-center py-12 bg-white rounded-xl border border-slate-200">
        <Package className="w-12 h-12 text-slate-400 mx-auto mb-4" />
        <p className="text-slate-600">Top stock tracking data will appear here</p>
      </div>
    </div>
  );
};

export default TopStock;
